import { render } from "./pop-up-get-password.vue?vue&type=template&id=26e8468e&scoped=true"
import script from "./pop-up-get-password.vue?vue&type=script&lang=js"
export * from "./pop-up-get-password.vue?vue&type=script&lang=js"

import "./pop-up-get-password.vue?vue&type=style&index=0&id=26e8468e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e8468e"]])

export default __exports__